export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betmen-themeWrapLive" */'./LiveThemeImporter'),
    ThemeImporter: () => import(/* webpackChunkName: "betmen-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betmen-themeWrapLive" */'./LiveThemeImporter'),
    ThemeImporter: () => import(/* webpackChunkName: "betmen-themeWrap" */'./ThemeImporter'),
  },
};
